module.exports = __webpack_public_path__ + "img/53.8fb89866.jpg";